export const initBlockData = {
  title: "Sample text",
  subTitle: "Sample text",
  blockBackgroundImage: "",
  blockBackgroundImageMobile: "",
};

export const initEmptyBlockData = {
  title: "",
  subTitle: "",
  blockBackgroundImage: "",
  blockBackgroundImageMobile: "",
};
